import script from "./DocumentsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsTab.vue?vue&type=style&index=0&id=1b4d35e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b4d35e8"]])

export default __exports__